module.exports = __webpack_public_path__ + "img/writing_hand.c6cda27c.gif";